export default __webpack_public_path__ + "static/media/flower-interstitial-bg.0b223585.webp";